// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wb_a bhm_b bhm_we"};